<template>
  <div>
    <content-template
      :menuName="$t('brrd.title')"
      :newButton="role_type !== 'admin'"
      @moveToForm="moveToForm()"
      :backButton="false"
    >
      <template #table-header>
        <span
          :class="`s-mb-30 ${isMobile ? 's-fullWidth' : 's-flex s-mt--65'}`"
        >
          <Input
            class="s-ml-auto"
            label=""
            :placeholder="$t('general.search')"
            v-model="request.search"
            @keyup="setTime()"
            @keydown="clearTime()"
            @keydown.tab="setTime()"
            @keyup.tab="clearTime()"
            @keypress.enter="getData()"
          />
        </span>
      </template>

      <template #table>
        <TableCustom
          :columns="columns"
          :request="request"
          :fetchData="fetchData"
          :data="rows"
          @setSortBy="setSortBy"
          @setShow="setShow"
          @getData="getData"
          @mouseleave="popup = null"
          @togglePopup="togglePopup"
        >
          <template #index="props">
            {{ curNumber(props.index) }}
          </template>

          <template #date="props">
            {{ convertDate(props.row.date) }}
          </template>

          <template #action="props">
            <div class="r-menu">
              <img
                class="r-isClickAble"
                :src="require('@/assets/icons/others/more.svg')"
               
              />
              <div
                class="r-menu-items"
                v-if="popup == curNumber(props.index)"
                @mouseleave="popup = -1"
              >
                <div
                  class="r-menu-item s-center-flex"
                  @click.prevent="setDetail(props.row)"
                  v-if="role_type == 'superadmin' || role_type == 'admin'"
                >
                  Detail
                </div>
                <div
                  class="r-menu-item s-center-flex"
                  @click.prevent="setFile(props.row)"
                >
                  {{ $t("general.uploadFile") }}
                </div>
                <div
                  class="r-menu-item s-center-flex"
                  @click.prevent="setUpdate(props.row)"
                >
                  {{ $t("general.update") }}
                </div>
                <div
                  class="r-menu-item s-text-red s-center-flex"
                  @click.prevent="openDeleteDialog(true, props.row)"
                >
                  {{ $t("general.delete") }}
                </div>
              </div>
            </div>
          </template>
        </TableCustom>
      </template>
    </content-template>

    <Modal v-if="dialogDelete" :title="$t('general.warning')">
      <template #modalContent>
        <p>{{ $t("general.modalDelete") }}</p>

        <div class="s-mtb-20 s-flex">
          <div class="s-ml-auto">
            <Button color="error" @click.prevent="onDelete">
              {{ $t("general.delete") }}
            </Button>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import ContentTemplate from "./contentTemplate.vue";
import tableMixins from "@/mixins/tableMixins";
import form from "@/mixins/form";
import { mapActions, mapGetters } from "vuex";
import { convertDate } from "@/common/timeformat";

export default {
  components: { ContentTemplate },
  mixins: [tableMixins, form],
  data() {
    return {
      columns: [
        {
          label: "No",
          fieldName: "index",
          isSortable: false,
          class: "r-table-firstColumn",
        },
        {
          label: "general.title",
          fieldName: "title",
          isSortable: true,
          class: "",
        },
        {
          label: "general.author",
          isSortable: true,
          fieldName: "creator_name",
          class: "",
        },
        {
          label: "general.date",
          isSortable: true,
          fieldName: "date",
          class: "",
        },
        {
          label: "Status",
          isSortable: true,
          fieldName: "status",
          class: "",
        },
        {
          label: "general.action",
          isSortable: false,
          fieldName: "action",
          class: "r-table-actionColumn",
        },
      ],
      current_id: "",
    };
  },

  mounted() {
    this.initData();
  },

  computed: {
    ...mapGetters({
      rows: "content/getContent",
      role_type: "auth/getRole",
      request: "content/getRequest",
    }),
    isMobile() {
      return this.$store.getters["getIsMobile"];
    },
    dialogDelete() {
      return this.$store.getters["getModal"];
    },
  },
  methods: {
    ...mapActions({
      setContent: "content/setContentData",
      setModal: "setModal",
      delete_brrd: "content/onDelete",
    }),
    async initData() {
      await this.getData();
    },

    async onDelete() {
      await this.delete_brrd(this.current_id);
      this.setModal(false);
      this.setContent();
    },

    moveToForm() {
      this.$router.push(
        this.$translate({ name: "New BRRD", params: { inputType: "New" } })
      );
    },

    async getData(type = 0) {
      this.fetchData = true;
      if (type === 0) this.request.page = 1;
      else this.request.page += type;
      await this.setContent();
      this.fetchData = false;
      // const response = this.getResponse("BRRD");
      // if (response.status !== 1) {
      //   this.showSnackbar({
      //     type: "error",
      //     text: response.msg,
      //   });
      // }
    },

    setDetail(data) {
      this.$router.push(
        this.$translate({
          name: "BRRD Detail",
          params: { slug: data.slug, item: data },
        })
      );
    },

    setFile(data) {
      this.$router.push(
        this.$translate({
          name: "BRRD File",
          params: { id: data.id },
        })
      );
    },

    setUpdate(data) {
      this.$router.push(
        this.$translate({
          name: "Edit BRRD",
          params: { slug: data.slug, inputType: "Edit" },
        })
      );
    },

    openDeleteDialog(state, data) {
      this.setModal(state);
      this.current_id = data.id;
    },
    convertDate(value) {
      return convertDate(value);
    },
  },
};
</script>
